import { Controller } from "@hotwired/stimulus"
import { useWindowResize } from "stimulus-use"

// Connects to data-controller="application--responsive"
export default class extends Controller {
  connect() {
    this.screen = ""

    useWindowResize(this)
  }

  windowResize() {
    this.responsive()
  }

  responsive() {
    if (document.body.clientWidth >= 1536) {
      this.screen = "2xl"
    } else if (document.body.clientWidth >= 1280) {
      this.screen = "xl"
    } else if (document.body.clientWidth >= 1024) {
      this.screen = "lg"
    } else if (document.body.clientWidth >= 768) {
      this.screen = "md"
    } else if (document.body.clientWidth >= 640) {
      this.screen = "sm"
    } else if (document.body.clientWidth <= 639) {
      this.screen = ""
    }

    document.body.dataset.screenSize = this.screen
  }
}
